import { useContext } from "react";
import ItemDetailsContext from "../contexts/ItemDetailsContext";

const useItemDetailsContext = () => useContext(ItemDetailsContext);

export default useItemDetailsContext;
